import { styled } from "goober";
import { isInAppNavigation } from "./Link";
import { Tab } from "./TabHeader";
import { Text } from "./Text";

const MorphIcon = styled("svg")`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-inline: -4px;
  overflow: visible;
  color: var(--600);
  stroke-width: 3px;

  [data-step-chevron] {
    transform-origin: 8px 8px;
    transform: translateX(0) rotate(0deg);
    transition:
      transform var(--motion-base) var(--ease-out),
      stroke-width var(--motion-base) var(--ease-out);
  }
`;

const Container = styled(Tab)`
  flex: 0 0 auto;
  width: max-content;
  max-width: 100px;
  height: 32px;
  padding: 8px 12px 8px 10px;
  gap: 4px;
  box-sizing: border-box;
  border-radius: 12px;
  color: var(--1000);

  &,
  &:hover,
  &:focus-visible {
    background: var(--200);
  }

  &:is(:hover, :focus-visible) [data-step-chevron] {
    stroke-width: 2px;
  }

  &:is(:hover, :focus-visible) [data-step-chevron="upper"] {
    transform: translateX(-2px) rotate(45deg);
  }

  &:is(:hover, :focus-visible) [data-step-chevron="lower"] {
    transform: translateX(-2px) rotate(-45deg);
  }
`;

export function StepPill({
  step,
  to,
  onNavigate,
}: {
  step: { name: string; color: string };
  to: string;
  onNavigate?: () => void;
}) {
  const stopFollow = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (isInAppNavigation(event)) onNavigate?.();
  };
  return (
    <Container
      to={to}
      onMouseDown={stopFollow}
      onClick={(event) => {
        if (event.detail === 0) stopFollow(event);
      }}
      aria-label="Back to workflow"
      title="Back to workflow"
      style={
        {
          "--200": `var(--${step.color}-200)`,
          "--600": `var(--${step.color}-600)`,
          "--1000": `var(--${step.color}-1000)`,
        } as React.CSSProperties
      }
    >
      <MorphIcon
        data-step-morph
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path
          data-step-chevron="upper"
          d="M8 8V3"
          vectorEffect="non-scaling-stroke"
        />
        <path
          data-step-chevron="lower"
          d="M8 8V13"
          vectorEffect="non-scaling-stroke"
        />
      </MorphIcon>
      <div style={{ minWidth: 0, flex: 1 }}>
        <Text variant="text-small-md" ellipsis>
          {step.name}
        </Text>
      </div>
    </Container>
  );
}
